export default "__VITE_ASSET__CK_g6qdS__"